import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ParcelIconComponent } from '../../../Parcel/Icon/parcelIcon.component';

interface ParcelTileDTO extends Core.ParcelTileDTO {
    isExternalReportingParcel?: boolean;
}

@Component({
    selector: 'parcel-tile-fmv',
    templateUrl: './parcelTileFMV.component.html',
    styleUrls: ['./parcelTileFMV.component.scss'],
    imports: [CommonModule, ParcelIconComponent]
})
export class ParcelTileFMVComponent {
    @Input() item: ParcelTileDTO;
    @Input() stateAllowConsolidating: boolean;
    @Input() ppReturnPreparationAllowed: boolean;
    @Output() navigateToParcel: EventEmitter<number> = new EventEmitter();
}
